import { ready } from "./utils";
import { jpcarrollSliders } from "./sliders";
import { loadMoreReviews } from "./load-more";
import { cf7MaskTelValidation } from "./cf7-mask-for-tel";
import { showMore } from "./showMore";

ready(() => {
  jpcarrollSliders();
  loadMoreReviews();
  cf7MaskTelValidation();
  showMore();
});
